/**
 * @see https://public.efsta.net/efr/AT/EFR_Guide_[AT]_v1.21_en.pdf#page=16
 */
export const EFSTAATTaxRates = [
  { rate: 20, name: 'Normal', group: 'A' },
  { rate: 10, name: 'Reduced-1', group: 'B' },
  { rate: 13, name: 'Reduced-2', group: 'C' },
  { rate: 0, name: 'Null', group: 'D' },
  { rate: 19, name: 'Special', group: 'E' },
  { rate: 7, name: '', group: 'F' },
  { rate: 5, name: 'Corona Lowered', group: 'G' },
];
